import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { RouteReuseStrategy } from '@angular/router';
import { CustomRouteReuseStrategy } from './shared/strategies/custom-route-reuse-strategy';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from '@angular/material/snack-bar';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldModule,
} from '@angular/material/form-field';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatMenuModule } from '@angular/material/menu';
import { initializeApp, provideFirebaseApp, getApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { provideFirestore, getFirestore, initializeFirestore } from '@angular/fire/firestore';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { environment } from './environments/environment';
import { ComponentsModule } from './components/components.module';
import { OverlayModule, OverlayRef } from '@angular/cdk/overlay';
import { UxserviceService } from './shared/services/uxservice.service';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatExpansionModule } from '@angular/material/expansion';
import { CoreModule } from './core/core.module';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CUSTOM_DATE_FORMATS } from './shared/customdateformat';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { DummyVendorComponent } from './views/dummy-vendor/dummy-vendor.component';
import { AuthModule } from './views/auth/auth.module';
import { CommonMessageDialogComponent } from './shared/components/common-message-dialog/common-message-dialog.component';
import { ListedEquipmentComponent } from './listed-equipment/listed-equipment.component';
import { SubscriptionManagementComponent } from './subscription-management/subscription-management.component';
import { AiButtonComponent } from './ai/ai-button/ai-button.component';
import { AiDrawerComponent } from './ai/ai-drawer/ai-drawer.component';
// import { ImportEquipmentReviewComponent } from './import-equipment-review/import-equipment-review.component';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);

}

@NgModule({
  declarations: [AppComponent, CommonMessageDialogComponent, ListedEquipmentComponent, SubscriptionManagementComponent],
  imports: [
    BrowserModule,
    CommonModule,
    AppRoutingModule,
    CoreModule,
    BrowserAnimationsModule,
    AiButtonComponent,
    AiDrawerComponent,
    DummyVendorComponent,
    BrowserAnimationsModule,
    MatDividerModule,
    ComponentsModule,
    AuthModule,
    HttpClientModule,
    MatSnackBarModule,
    OverlayModule,
    MatSidenavModule,
    MatListModule,
    MatToolbarModule,
    MatExpansionModule,
    MatMenuModule,
    MatDatepickerModule,
    MatIconModule,
    MatNativeDateModule,
    MatInputModule,
    MatPaginatorModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth()),
    provideDatabase(() => getDatabase()),
    provideFirestore(() =>
      initializeFirestore(getApp(), { experimentalForceLongPolling: true }),
    ),
    provideStorage(() => getStorage()),
    provideFunctions(() => getFunctions()),
  ],
  providers: [
    {
      provide: OverlayRef,
      useValue: {},
    },
    { provide: MAT_DATE_FORMATS, useValue: CUSTOM_DATE_FORMATS },
    UxserviceService,
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { floatLabel: 'always' },
    },
    HttpClient,
    {
      provide: RouteReuseStrategy,
      useClass: CustomRouteReuseStrategy,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }